var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(['Chat'].indexOf(_vm.$route.name) == -1)?_c('Navbar'):_vm._e(),_c('div',{class:['Chat'].indexOf(_vm.$route.name) == -1 ? 'main':''},[_c('router-view')],1),(['Chat'].indexOf(_vm.$route.name) == -1)?_c('Footer'):_vm._e(),_c('Contact'),_c('LoginModal'),_c('LogoutModal'),_c('RegisterModal'),_c('RestoreModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }